import ViewBase from "../../../../framework/core/mvvm/view_base";
import LanguageManager from "../../../../manager/language_manager";
import { TexasHoldSprite } from "../../../texasholdem/module/table/component/texas_hold_sprite";

const {ccclass, property} = cc._decorator;

@ccclass
export  class JdChipsView extends ViewBase {
    @property(cc.Slider)
    slider:cc.Slider = null;

    @property(cc.ProgressBar)
    progressBar:cc.ProgressBar = null;
    

    @property(cc.Label)
    sliderLab:cc.Label=null;

    @property(cc.Label)
    totalGold:cc.Label=null;

    @property(cc.Toggle)
    toggle:cc.Toggle=null;

    @property(cc.Label)
    minLab:cc.Label=null;

    @property(cc.Label)
    maxLab:cc.Label=null;

    @property(cc.Node)
    grayNode:cc.Node = null;

    @property(cc.Button)
    handle:cc.Button = null;

    @property(cc.Button)
    conformBtn:cc.Button = null;

    @property(cc.Node)
    moneytips:cc.Node = null;

    @property(cc.Label)
    moneyType:cc.Label = null;

    @property(TexasHoldSprite)
    sliderType:TexasHoldSprite = null;

    @property(TexasHoldSprite)
    totalMoney:TexasHoldSprite = null;


    onLoad(){
        this.progressBar.progress = this.slider.progress;
        this.moneytips.active = false;
        this.slider.node.on('slide', function(event){
            this.progressBar.progress = this.slider.progress;
        }, this);
    }

    isGraySlider(isgray:boolean){
        this.grayNode.active = isgray;
    }

    updateMoneyType(isMango:boolean){
        // let str = isMango ? 'mangguo' : 'chouma';
        // this.totalMoney.setSprite(str);
        // this.sliderType.setSprite(str);
        // if (isMango) {
        //     this.moneyType.string = LanguageManager.t('Public_Mango') + ':';
        // }else{
        //     this.moneyType.string = 'ซีปที่มี:';
        // }
    }

    isForbidOperator(isFrobid:boolean){
        this.isGraySlider(isFrobid);
        this.conformBtn.interactable = !isFrobid;
        this.handle.interactable = !isFrobid;
        this.moneytips.active = isFrobid;
    }
}
